
// reactstrap components
import AddChildAccountModal from "components/Modals/AddChildAccountModal";
import AddKeyModal from "components/Modals/AddKeyModal";
import AddSocialRecoveryModal from "components/Modals/AddSocialRecoveryModal";
import { useState } from "react";
import { Card, CardBody, CardTitle, Container, Row, Col, Button } from "reactstrap";
import {  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const PortfolioManagerHeader = ({accountData}) => {
  const [addKeyModal, setAddKeyModal] = useState(false);
  const addKeyModalToggle = () => setAddKeyModal(!addKeyModal);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row className="justify-content-center mb-4">

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"100px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Total Tokens
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{accountData?.tokens?.length || 0}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                          <i className="fas fa-check" />
                        </div>
                      </Col>
                    </Row>
                    
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"100px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Total NFT's
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{accountData?.nfts?.length || 0}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-red text-white rounded-circle shadow">
                          <i className="fas fa-info" />
                        </div>
                      </Col>
                    </Row>
                   
                  </CardBody>
                </Card>
              </Col>
              
            </Row>


            <Row className="justify-content-center">

             
              {/* <Col lg="12" xl="12" >
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"100px"}}>
                  <CardBody> */}
                  
                   
                  {/* </CardBody>
                </Card>
              </Col> */}
              
            </Row>

           
          </div>
        </Container>
      </div>

      <AddChildAccountModal modal={addKeyModal} toggle={addKeyModalToggle} />
    </>
  );
};

export default PortfolioManagerHeader;
